import { h } from 'preact';
import PropTypes from 'prop-types';

import { IconPlayBlurred } from '../../1-foundation/icons/icons';
import { getClassNames } from '../../../../utils/classnames-utils';
import { getTimeElapsed } from '../../../../utils/dates';

import { modifierList } from './props-list';

const DEFAULT_MODIFIERS = [];
const DEFAULT_TAG = 'button';

const VideoCardInlineSlim = ({
  modifiers = DEFAULT_MODIFIERS,
  imageSrc,
  title,
  index,
  onClick,
  duration,
  publishedTime,
  time,
  href,
  tag = DEFAULT_TAG,
  intcmp,
}) => {
  const Tag = tag;
  const tagType = tag === 'button' ? 'button' : undefined;
  const tagHref = tag === 'button' ? undefined : href;
  const classNames = getClassNames('c-video-card-inline-slim', modifiers);
  const timeToShow = publishedTime && duration ? `${duration} MIN | ${getTimeElapsed(publishedTime)}` : time;

  return (
    <Tag className={classNames} onClick={(e) => onClick(index, e)} type={tagType} href={tagHref} data-intcmp={intcmp}>
      <article className="c-video-card-inline-slim__wrapper">
        <div className="c-video-card-inline-slim__img-container">
          <img className="c-video-card-inline-slim__img" src={imageSrc} alt={title} />
          <IconPlayBlurred modifiers={['media', 'play-blurred', 'medium']} />
        </div>
        <div className="c-video-card-inline-slim__text-wrapper">
          <h2 className="c-video-card-inline-slim__title">{title}</h2>
          <time dateTime={timeToShow} className="c-video-card-inline-slim__date">
            {timeToShow}
          </time>
        </div>
      </article>
    </Tag>
  );
};

VideoCardInlineSlim.propTypes = {
  tag: PropTypes.string,
  href: PropTypes.string,
  index: PropTypes.number,
  onClick: PropTypes.func,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  duration: PropTypes.string,
  publishedTime: PropTypes.string,
  time: PropTypes.string,
  intcmp: PropTypes.string,
};

export default VideoCardInlineSlim;
